import {html} from "./utils/environment";

import codyhouseModalVideo from "./components/codyhouse-modalvideo";
import cursor from "./components/cursor";
import video from "./components/video";

console.log("Started JS App");

html.classList.add("is-loaded");
html.classList.add("is-ready");
html.classList.remove("is-loading");

codyhouseModalVideo();
cursor();
video();
